import rootReducer from './rootReducer'
import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk';

const middlewares = [];
 
if (process.env.NODE_ENV === `test`) { // using logger in dev environment
  const { logger } = require(`redux-logger`);
 
  middlewares.push(logger);
}

const initialState = {
    
  };

  const store = configureStore({
    reducer: rootReducer,
    middleware: [thunk, ...middlewares],
    devTools: true,
    preloadedState: initialState,
  });

export default store;